export const file_copy = () => (
  <path
    d="M14 5H9a2 2 0 00-2 2v13a2 2 0 002 2h9a2 2 0 002-2v-9m-6-6l6 6m-6-6v6h6m-6-9H6a2 2 0 00-2 2v14"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
